import ElectricalPerformance from './ElectricalPerformance';

export default ElectricalPerformance;
